import { Tooltip } from '@mui/material';
import type { SVGProps } from 'react';

export const MyDashboardHomeIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <Tooltip title={'My Dashboard'}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M4.00002 17.281C4.45195 17.418 5.06237 17.418 6.1 17.418H13.9C14.9376 17.418 15.548 17.418 16 17.281M4.00002 17.281C3.90312 17.2517 3.8135 17.216 3.72852 17.1727C3.30516 16.957 2.96095 16.6128 2.74524 16.1894C2.5 15.7081 2.5 15.0781 2.5 13.818V6.01797C2.5 4.75785 2.5 4.12779 2.74524 3.64649C2.96095 3.22313 3.30516 2.87892 3.72852 2.6632C4.20982 2.41797 4.83988 2.41797 6.1 2.41797H13.9C15.1601 2.41797 15.7902 2.41797 16.2715 2.6632C16.6948 2.87892 17.039 3.22313 17.2548 3.64649C17.5 4.12779 17.5 4.75785 17.5 6.01797V13.818C17.5 15.0781 17.5 15.7081 17.2548 16.1894C17.039 16.6128 16.6948 16.957 16.2715 17.1727C16.1865 17.216 16.0969 17.2517 16 17.281M4.00002 17.281C4.00026 16.674 4.0039 16.3529 4.05764 16.0827C4.29436 14.8926 5.22466 13.9623 6.41473 13.7256C6.70453 13.668 7.05302 13.668 7.75 13.668H12.25C12.947 13.668 13.2955 13.668 13.5853 13.7256C14.7753 13.9623 15.7056 14.8926 15.9424 16.0827C15.9961 16.3529 15.9997 16.674 16 17.281M13 8.04297C13 9.69982 11.6569 11.043 10 11.043C8.34315 11.043 7 9.69982 7 8.04297C7 6.38611 8.34315 5.04297 10 5.04297C11.6569 5.04297 13 6.38611 13 8.04297Z"
          // stroke="#B5BCC4"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </Tooltip>
  );
};

export const MyDepartmentDashboardIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <Tooltip title={'Department Dashboard'}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <path
          d="M7 2.5H3.83333C3.36662 2.5 3.13327 2.5 2.95501 2.59083C2.79821 2.67072 2.67072 2.79821 2.59083 2.95501C2.5 3.13327 2.5 3.36662 2.5 3.83333V7C2.5 7.46671 2.5 7.70007 2.59083 7.87833C2.67072 8.03513 2.79821 8.16261 2.95501 8.24251C3.13327 8.33333 3.36662 8.33333 3.83333 8.33333H7C7.46671 8.33333 7.70007 8.33333 7.87833 8.24251C8.03513 8.16261 8.16261 8.03513 8.24251 7.87833C8.33333 7.70007 8.33333 7.46671 8.33333 7V3.83333C8.33333 3.36662 8.33333 3.13327 8.24251 2.95501C8.16261 2.79821 8.03513 2.67072 7.87833 2.59083C7.70007 2.5 7.46671 2.5 7 2.5Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
        <path
          d="M16.1667 2.5H13C12.5333 2.5 12.2999 2.5 12.1217 2.59083C11.9649 2.67072 11.8374 2.79821 11.7575 2.95501C11.6667 3.13327 11.6667 3.36662 11.6667 3.83333V7C11.6667 7.46671 11.6667 7.70007 11.7575 7.87833C11.8374 8.03513 11.9649 8.16261 12.1217 8.24251C12.2999 8.33333 12.5333 8.33333 13 8.33333H16.1667C16.6334 8.33333 16.8667 8.33333 17.045 8.24251C17.2018 8.16261 17.3293 8.03513 17.4092 7.87833C17.5 7.70007 17.5 7.46671 17.5 7V3.83333C17.5 3.36662 17.5 3.13327 17.4092 2.95501C17.3293 2.79821 17.2018 2.67072 17.045 2.59083C16.8667 2.5 16.6334 2.5 16.1667 2.5Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
        <path
          d="M16.1667 11.6667H13C12.5333 11.6667 12.2999 11.6667 12.1217 11.7575C11.9649 11.8374 11.8374 11.9649 11.7575 12.1217C11.6667 12.2999 11.6667 12.5333 11.6667 13V16.1667C11.6667 16.6334 11.6667 16.8667 11.7575 17.045C11.8374 17.2018 11.9649 17.3293 12.1217 17.4092C12.2999 17.5 12.5333 17.5 13 17.5H16.1667C16.6334 17.5 16.8667 17.5 17.045 17.4092C17.2018 17.3293 17.3293 17.2018 17.4092 17.045C17.5 16.8667 17.5 16.6334 17.5 16.1667V13C17.5 12.5333 17.5 12.2999 17.4092 12.1217C17.3293 11.9649 17.2018 11.8374 17.045 11.7575C16.8667 11.6667 16.6334 11.6667 16.1667 11.6667Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
        <path
          d="M7 11.6667H3.83333C3.36662 11.6667 3.13327 11.6667 2.95501 11.7575C2.79821 11.8374 2.67072 11.9649 2.59083 12.1217C2.5 12.2999 2.5 12.5333 2.5 13V16.1667C2.5 16.6334 2.5 16.8667 2.59083 17.045C2.67072 17.2018 2.79821 17.3293 2.95501 17.4092C3.13327 17.5 3.36662 17.5 3.83333 17.5H7C7.46671 17.5 7.70007 17.5 7.87833 17.4092C8.03513 17.3293 8.16261 17.2018 8.24251 17.045C8.33333 16.8667 8.33333 16.6334 8.33333 16.1667V13C8.33333 12.5333 8.33333 12.2999 8.24251 12.1217C8.16261 11.9649 8.03513 11.8374 7.87833 11.7575C7.70007 11.6667 7.46671 11.6667 7 11.6667Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </svg>
    </Tooltip>
  );
};

export const PatientIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <Tooltip title={'Patients'}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <path
          d="M14.5365 13.0231C15.6355 13.5751 16.5777 14.4611 17.2654 15.5689C17.4016 15.7883 17.4697 15.898 17.4932 16.0499C17.5411 16.3586 17.33 16.7381 17.0425 16.8602C16.901 16.9203 16.7419 16.9203 16.4236 16.9203M13.0269 9.77383C14.1453 9.21802 14.9139 8.06387 14.9139 6.7302C14.9139 5.39654 14.1453 4.24239 13.0269 3.68657M11.5172 6.7302C11.5172 8.60615 9.99646 10.1269 8.12051 10.1269C6.24456 10.1269 4.72381 8.60615 4.72381 6.7302C4.72381 4.85425 6.24456 3.3335 8.12051 3.3335C9.99646 3.3335 11.5172 4.85425 11.5172 6.7302ZM2.88145 15.3641C4.08488 13.5572 5.98389 12.3914 8.12051 12.3914C10.2571 12.3914 12.1562 13.5572 13.3596 15.3641C13.6232 15.76 13.755 15.9579 13.7399 16.2107C13.728 16.4076 13.599 16.6486 13.4417 16.7675C13.2397 16.9203 12.9618 16.9203 12.4061 16.9203H3.83489C3.2792 16.9203 3.00136 16.9203 2.79934 16.7675C2.64204 16.6486 2.51299 16.4076 2.50118 16.2107C2.486 15.9579 2.61782 15.76 2.88145 15.3641Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </svg>
    </Tooltip>
  );
};

export const DailySessionNotesIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <Tooltip title={'Daily Session Notes'}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <path
          d="M10.8334 2.70215V5.80005C10.8334 6.22009 10.8334 6.43011 10.9151 6.59055C10.987 6.73167 11.1018 6.8464 11.2429 6.91831C11.4033 7.00005 11.6133 7.00005 12.0334 7.00005H15.1313M10.8334 13.75H6.33337M12.3334 10.75H6.33337M15.3334 8.49117V13.9C15.3334 15.1601 15.3334 15.7902 15.0881 16.2715C14.8724 16.6948 14.5282 17.039 14.1049 17.2548C13.6236 17.5 12.9935 17.5 11.7334 17.5H6.93337C5.67326 17.5 5.0432 17.5 4.5619 17.2548C4.13853 17.039 3.79432 16.6948 3.57861 16.2715C3.33337 15.7902 3.33337 15.1601 3.33337 13.9V6.1C3.33337 4.83988 3.33337 4.20982 3.57861 3.72852C3.79432 3.30516 4.13853 2.96095 4.5619 2.74524C5.0432 2.5 5.67326 2.5 6.93337 2.5H9.34221C9.89253 2.5 10.1677 2.5 10.4266 2.56217C10.6562 2.61729 10.8757 2.7082 11.077 2.83156C11.3041 2.9707 11.4986 3.16527 11.8878 3.55442L14.279 5.94558C14.6681 6.33473 14.8627 6.5293 15.0018 6.75636C15.1252 6.95767 15.2161 7.17715 15.2712 7.40673C15.3334 7.66568 15.3334 7.94084 15.3334 8.49117Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </svg>
    </Tooltip>
  );
};

export const SchedulingIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <Tooltip title={'Scheduling'}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <path
          d="M16 8.5H2.5M12.25 2.5V5.5M6.25 2.5V5.5M6.1 17.5H12.4C13.6601 17.5 14.2902 17.5 14.7715 17.2548C15.1948 17.039 15.539 16.6948 15.7548 16.2715C16 15.7902 16 15.1601 16 13.9V7.6C16 6.33988 16 5.70982 15.7548 5.22852C15.539 4.80516 15.1948 4.46095 14.7715 4.24524C14.2902 4 13.6601 4 12.4 4H6.1C4.83988 4 4.20982 4 3.72852 4.24524C3.30516 4.46095 2.96095 4.80516 2.74524 5.22852C2.5 5.70982 2.5 6.33988 2.5 7.6V13.9C2.5 15.1601 2.5 15.7902 2.74524 16.2715C2.96095 16.6948 3.30516 17.039 3.72852 17.2548C4.20982 17.5 4.83988 17.5 6.1 17.5Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </svg>
    </Tooltip>
  );
};

export const SkillRCIcons = (props: SVGProps<SVGSVGElement>) => {
  return (
    <Tooltip title={'Skill RC'}>
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect
          x="0.635254"
          width="20"
          height="20"
          rx="3.31081"
          fill="#76CE82"
        />
        <path
          d="M7.30231 13.5746L5.71509 10.7039H5.03485V13.5746H3.59192V6.20801H6.29226C6.84882 6.20801 7.32292 6.31003 7.71458 6.51407C8.10623 6.71107 8.39825 6.98195 8.59064 7.32671C8.7899 7.66443 8.88953 8.04437 8.88953 8.46652C8.88953 8.952 8.75211 9.39174 8.47727 9.78575C8.20242 10.1727 7.79359 10.4401 7.25078 10.5878L8.97199 13.5746H7.30231ZM5.03485 9.59578H6.24073C6.63238 9.59578 6.9244 9.50079 7.11679 9.31083C7.30918 9.11382 7.40538 8.84294 7.40538 8.49818C7.40538 8.16046 7.30918 7.90013 7.11679 7.7172C6.9244 7.52723 6.63238 7.43225 6.24073 7.43225H5.03485V9.59578Z"
          fill="white"
        />
        <path
          d="M10.1963 8.00535L10.1963 8.00542C9.87802 8.57304 9.71911 9.21741 9.71911 9.938C9.71911 10.6586 9.87802 11.303 10.1963 11.8706L10.1964 11.8708C10.5214 12.438 10.9607 12.883 11.5141 13.2053L11.5144 13.2054C12.0748 13.5207 12.7007 13.6782 13.3918 13.6782C14.207 13.6782 14.9161 13.4718 15.5183 13.0582L15.5183 13.0581C16.1276 12.6375 16.5532 12.052 16.7952 11.3026L16.8039 11.2756H16.7755H15.1146H15.1015L15.0959 11.2874C14.9324 11.6323 14.7012 11.8937 14.4025 12.0725C14.1104 12.2445 13.7703 12.3308 13.3814 12.3308C12.9654 12.3308 12.5943 12.2342 12.2677 12.0413C11.948 11.8415 11.6961 11.5624 11.5121 11.2035C11.3349 10.8376 11.246 10.4159 11.246 9.938C11.246 9.45301 11.335 9.03142 11.5121 8.67262C11.6961 8.31364 11.948 8.03806 12.2677 7.84519L12.2678 7.84512C12.5944 7.64528 12.9654 7.54517 13.3814 7.54517C13.7703 7.54517 14.1104 7.6315 14.4026 7.80351L14.4027 7.80362C14.7013 7.97544 14.9324 8.23328 15.0959 8.57816L15.1015 8.58999H15.1146H16.7755H16.804L16.7952 8.56288C16.5531 7.82049 16.1275 7.23852 15.5183 6.81787C14.9093 6.39733 14.2002 6.18731 13.3918 6.18731C12.7007 6.18731 12.0747 6.34834 11.5142 6.67066C10.9607 6.98603 10.5213 7.43107 10.1963 8.00535Z"
          fill="white"
          stroke="white"
          strokeWidth="0.0413864"
        />
        <ellipse
          cx="17.7935"
          cy="12.8297"
          rx="0.827703"
          ry="0.827703"
          fill="#0A9ECC"
        />
      </svg>
    </Tooltip>
  );
};

export const LaborManagementIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <Tooltip title={'Labor Management'}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <path
          d="M6.625 5.5H8.6875M6.625 8.5H8.6875M6.625 11.5H8.6875M11.3125 5.5H13.375M11.3125 8.5H13.375M11.3125 11.5H13.375M16 16V4.9C16 4.05992 16 3.63988 15.8365 3.31901C15.6927 3.03677 15.4632 2.8073 15.181 2.66349C14.8601 2.5 14.4401 2.5 13.6 2.5H6.4C5.55992 2.5 5.13988 2.5 4.81901 2.66349C4.53677 2.8073 4.3073 3.03677 4.16349 3.31901C4 3.63988 4 4.05992 4 4.9V16M17.5 16H2.5"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </svg>
    </Tooltip>
  );
};

export const MonthEndAlertIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <Tooltip title={'Monthly Closeout Alerts'}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <path
          d="M9.33337 10L6.12871 7.32945C5.65257 6.93266 5.4145 6.73427 5.24335 6.49108C5.09171 6.2756 4.97909 6.03516 4.91063 5.78071C4.83337 5.49354 4.83337 5.18364 4.83337 4.56385V2.5M9.33337 10L12.538 7.32945C13.0142 6.93267 13.2522 6.73427 13.4234 6.49108C13.575 6.2756 13.6877 6.03516 13.7561 5.78071C13.8334 5.49354 13.8334 5.18364 13.8334 4.56385V2.5M9.33337 10L6.12871 12.6706C5.65257 13.0673 5.4145 13.2657 5.24335 13.5089C5.09171 13.7244 4.97909 13.9648 4.91063 14.2193C4.83337 14.5065 4.83337 14.8164 4.83337 15.4361V17.5M9.33337 10L12.538 12.6706C13.0142 13.0673 13.2522 13.2657 13.4234 13.5089C13.575 13.7244 13.6877 13.9648 13.7561 14.2193C13.8334 14.5065 13.8334 14.8164 13.8334 15.4361V17.5M3.33337 2.5H15.3334M3.33337 17.5H15.3334"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </svg>
    </Tooltip>
  );
};

export const ReportsIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <Tooltip title={'Reports'}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        {...props}
      >
        <path
          d="M6.33337 11.5V14.5M12.3334 10V14.5M9.33337 7V14.5M15.3334 6.1V13.9C15.3334 15.1601 15.3334 15.7902 15.0881 16.2715C14.8724 16.6948 14.5282 17.039 14.1049 17.2548C13.6236 17.5 12.9935 17.5 11.7334 17.5H6.93337C5.67326 17.5 5.0432 17.5 4.5619 17.2548C4.13853 17.039 3.79432 16.6948 3.57861 16.2715C3.33337 15.7902 3.33337 15.1601 3.33337 13.9V6.1C3.33337 4.83988 3.33337 4.20982 3.57861 3.72852C3.79432 3.30516 4.13853 2.96095 4.5619 2.74524C5.0432 2.5 5.67326 2.5 6.93337 2.5H11.7334C12.9935 2.5 13.6236 2.5 14.1049 2.74524C14.5282 2.96095 14.8724 3.30516 15.0881 3.72852C15.3334 4.20982 15.3334 4.83988 15.3334 6.1Z"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
        />
      </svg>
    </Tooltip>
  );
};

export const RWSkillIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <Tooltip title={'RW Skill'}>
      <svg
        width="21"
        height="20"
        viewBox="0 0 21 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect
          x="0.25"
          width="20"
          height="20"
          rx="3.31081"
          fill="#71C7FB"
        />
        <path
          d="M6.13737 13.6235L4.59256 10.895H3.9305V13.6235H2.52612V6.62158H5.15431C5.696 6.62158 6.15744 6.71855 6.53862 6.91249C6.91981 7.09975 7.20403 7.35722 7.39128 7.68492C7.58522 8.00592 7.68218 8.36705 7.68218 8.76831C7.68218 9.22976 7.54843 9.64773 7.28093 10.0222C7.01343 10.3901 6.61553 10.6442 6.08722 10.7846L7.76243 13.6235H6.13737ZM3.9305 9.84168H5.10415C5.48534 9.84168 5.76956 9.75139 5.95681 9.57083C6.14406 9.38357 6.23768 9.1261 6.23768 8.79841C6.23768 8.4774 6.14406 8.22996 5.95681 8.05608C5.76956 7.87551 5.48534 7.78523 5.10415 7.78523H3.9305V9.84168Z"
          fill="white"
        />
        <path
          d="M17.2501 6.77832L15.4162 13.6138H13.8644L12.6324 8.7467L11.3439 13.6138L9.80154 13.6236L8.03345 6.77832H9.44416L10.6009 12.0861L11.9364 6.77832H13.4036L14.6638 12.0567L15.83 6.77832H17.2501Z"
          fill="white"
        />
        <ellipse
          cx="17.6557"
          cy="12.8043"
          rx="0.819426"
          ry="0.819421"
          fill="#F04C58"
        />
      </svg>
    </Tooltip>
  );
};

export const RSSkillIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <Tooltip title={'RS Skill'}>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <rect
          width="20"
          height="20"
          rx="3.31081"
          fill="#F04C58"
        />
        <path
          d="M7.51007 13.6573L5.86656 10.7544H5.1622V13.6573H3.66809V6.20801H6.4642C7.0405 6.20801 7.53142 6.31117 7.93696 6.51751C8.3425 6.71672 8.64488 6.99065 8.8441 7.33928C9.05042 7.6808 9.15359 8.065 9.15359 8.4919C9.15359 8.98283 9.01129 9.42751 8.7267 9.82595C8.44211 10.2173 8.01878 10.4876 7.45671 10.637L9.23897 13.6573H7.51007ZM5.1622 9.63384H6.41084C6.81638 9.63384 7.11876 9.53779 7.31797 9.34569C7.51719 9.14647 7.61679 8.87255 7.61679 8.52392C7.61679 8.1824 7.51719 7.91915 7.31797 7.73416C7.11876 7.54206 6.81638 7.446 6.41084 7.446H5.1622V9.63384Z"
          fill="white"
        />
        <path
          d="M12.6846 13.8059C12.1674 13.8059 11.6999 13.7173 11.2819 13.5402C10.871 13.3631 10.5451 13.1081 10.3043 12.7751C10.0634 12.4421 9.93946 12.049 9.93237 11.5956H11.5263C11.5476 11.9002 11.6538 12.1411 11.8451 12.3182C12.0434 12.4953 12.3126 12.5838 12.6527 12.5838C12.9998 12.5838 13.2725 12.5024 13.4709 12.3394C13.6692 12.1694 13.7684 11.9498 13.7684 11.6806C13.7684 11.461 13.7011 11.2803 13.5665 11.1386C13.4319 10.997 13.2619 10.8872 13.0565 10.8092C12.8581 10.7242 12.5818 10.6321 12.2276 10.5329C11.7459 10.3913 11.3527 10.2531 11.0481 10.1185C10.7506 9.97683 10.492 9.76784 10.2724 9.49156C10.0599 9.20819 9.95363 8.83272 9.95363 8.36516C9.95363 7.92594 10.0634 7.54339 10.283 7.21751C10.5026 6.89164 10.8108 6.64369 11.2075 6.47367C11.6042 6.29656 12.0576 6.20801 12.5677 6.20801C13.3327 6.20801 13.9526 6.39574 14.4272 6.77121C14.909 7.13959 15.1746 7.65674 15.2242 8.32266H13.5878C13.5736 8.06762 13.4638 7.85864 13.2584 7.6957C13.06 7.52568 12.7944 7.44067 12.4614 7.44067C12.171 7.44067 11.9372 7.51505 11.7601 7.66382C11.5901 7.81259 11.505 8.02866 11.505 8.31203C11.505 8.51039 11.5688 8.67687 11.6963 8.81147C11.8309 8.93899 11.9938 9.04525 12.1851 9.13026C12.3835 9.20819 12.6598 9.30028 13.014 9.40655C13.4957 9.54823 13.8888 9.68992 14.1935 9.8316C14.4981 9.97329 14.7602 10.1858 14.9798 10.4692C15.1994 10.7526 15.3092 11.1245 15.3092 11.585C15.3092 11.9817 15.2065 12.3501 15.0011 12.6901C14.7956 13.0301 14.4945 13.3029 14.0978 13.5083C13.7011 13.7067 13.23 13.8059 12.6846 13.8059Z"
          fill="white"
        />
        <ellipse
          cx="17.0167"
          cy="12.8297"
          rx="0.827703"
          ry="0.827703"
          fill="#76CE82"
        />
      </svg>
    </Tooltip>
  );
};
